import classNames from 'classnames'
import { useAtom } from 'jotai'
import { PictureCardUpload } from '~/components/business/PictureCardUpload'
import { MyForm } from '~/components/ui/MyForm'
import { toCDNImage } from '~/utils'
import { initImageUrlAtom } from './atom'
import styles from '../AiForm.module.css'
import { useForm } from './useForm'

export const LabInitImageComp = () => {
  const [initImageUrl, setInitImageUrl] = useAtom(initImageUrlAtom)
  const { setPrefineOptions } = useForm()

  const getImageSize = ({
    width,
    height,
  }: {
    width: number
    height: number
  }) => {
    setPrefineOptions({
      width,
      height,
    })
  }

  return (
    <MyForm.Item
      label="* 上传图片"
      className={classNames(styles.borderLessFormItem, '!mb-8')}
    >
      <PictureCardUpload
        className={classNames(styles.customUpload, 'relative z-10')}
        needHash={false}
        limit={10}
        height={326}
        icon={
          <img
            src={toCDNImage('/images/ai/image.png')}
            alt=""
            className="w-20 h-20 block mx-auto mb-2.5"
          />
        }
        label={
          <>
            <div className="text-sm text-neutral-500 font-semibold mb-2.5">
              拖拽图片到这里，或点击上传
            </div>
            <div className="text-xs text-neutral-400">
              支持图片格式：JPG,PNG，Max：10MB
            </div>
          </>
        }
        showInfo={false}
        value={initImageUrl}
        onChange={val => setInitImageUrl(val)}
        getImageSize={getImageSize}
      ></PictureCardUpload>
    </MyForm.Item>
  )
}
